<template>
  <nx-bform-group 
  :label="requiredLabel(name)" 
  v-bind="$attrs"
  :description="defaultDescription"
  >
    <slot>
      <nx-bform-input
        :name="name"
        :rules="{ required, email: true }"
        :value="$attrs.value"
        @input="$listeners.input"
      />
    </slot>
  </nx-bform-group>
</template>

<script>
import FormGroupMixin from "../form-group.mixin";

export default {
  props: {
    description: {
      type: String
    },
    message: {}
  },  
  mixins: [FormGroupMixin],
  computed: {
    name() {
      return this.label || this.$t("email");
    },
    defaultDescription() {
      return this.message === "true"
        ? this.$t("emailDesc")
        : null;
    }
  }
};
</script>

<i18n src="@/locales/login.locale.json" />
